/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `expedia` - Payment is taken by Expedia.
 * * `gondola` - Payment is taken by Gondola.
 * * `property` - Payment is taken by the property.
 * 
 * @export
 */
export const MerchantOfRecord = {
    Expedia: 'expedia',
    Gondola: 'gondola',
    Property: 'property'
} as const;
export type MerchantOfRecord = typeof MerchantOfRecord[keyof typeof MerchantOfRecord];


export function instanceOfMerchantOfRecord(value: any): boolean {
    for (const key in MerchantOfRecord) {
        if (Object.prototype.hasOwnProperty.call(MerchantOfRecord, key)) {
            if (MerchantOfRecord[key as keyof typeof MerchantOfRecord] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MerchantOfRecordFromJSON(json: any): MerchantOfRecord {
    return MerchantOfRecordFromJSONTyped(json, false);
}

export function MerchantOfRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantOfRecord {
    return json as MerchantOfRecord;
}

export function MerchantOfRecordToJSON(value?: MerchantOfRecord | null): any {
    return value as any;
}

export function MerchantOfRecordToJSONTyped(value: any, ignoreDiscriminator: boolean): MerchantOfRecord {
    return value as MerchantOfRecord;
}

